import { createFileRoute } from '@tanstack/react-router';

import { OverviewTab } from '@/features/deals';

export const Route = createFileRoute('/_app/deals/$dealId/')({
  component: function Tab() {
    const { dealId } = Route.useParams();
    return <OverviewTab dealId={dealId} />;
  },
});
